import * as yup from 'yup'

export const schema = yup
  .object()
  .shape({
    name: yup.string().required('Nome é obrigatório!'),
    password: yup
      .string()
      .min(6, 'Senha precisa de no minimo 6 carctere!')
      .required('Nome é obrigatório!'),
  })
  .required()

export type FieldLogin = yup.InferType<typeof schema>
